import { ApiResponse } from 'apisauce'
import { parseISO } from 'date-fns'
import { PaginatedList } from '../../../model/Pagination'
import { ResourceHistoryDetails } from '../../../model/ResourceHistory'
import { ResourceHistoryApi } from './resourceHistory.model'

const deserializeResourceHistory = ({
  date,
  ...resource
}: ResourceHistoryApi): ResourceHistoryDetails => ({
  ...resource,
  date: parseISO(date),
})

export const deserializeResourceHistoryResponse = (
  response: ApiResponse<PaginatedList<ResourceHistoryApi>>,
): ApiResponse<PaginatedList<ResourceHistoryDetails>> => {
  const { data, ...responseRest } = response
  if (!response.ok || !data) {
    return { ...responseRest }
  }
  return {
    ...responseRest,
    data: {
      ...data,
      items: data.items.map(deserializeResourceHistory),
    },
  }
}
